import { User } from '@/models/User';
import { birthday } from '@/support/Date';
export class Student extends User {
    constructor() {
        super(...arguments);
        this.$name = 'Student';
        this.$fillable = ['avatar', 'first_name', 'middle_name', 'last_name', 'dob', 'email', 'password', 'current_password', 'student', 'roles', 'groups', 'level', 'relationships', 'phone', 'tags', 'treatment', 'parnassys_id'];
        this.filters = {
            role: 'student',
        };
    }
    setDobAttribute(value) {
        this.age = birthday(value);
        return value;
    }
    url() {
        return '/students/' + this.id;
    }
    updateTreatmentLabels(payload) {
        const url = `${this.$endpoint}/${this.id}/relationships/treatment-labels`;
        return this.request('put', url, payload);
    }
    setLvsResultsEndpoint() {
        this.$endpoint = `/students/${this.id}/relationships/lvs-results`;
        return this;
    }
    setLvsAreasEndpoint() {
        this.$endpoint = `/students/${this.id}/relationships/lvs-areas`;
        return this;
    }
}
